export default __webpack_public_path__ + "static/media/fundo.7cf6e1bb.jpg";